import { Component, OnInit, OnDestroy } from '@angular/core';
import { MasqueradeService } from '../../services/masquerade.service';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-masquerade-banner',
    templateUrl: './masquerade-banner.component.html',
    styleUrls: ['./masquerade-banner.component.scss'],
})
export class MasqueradeBannerComponent implements OnInit, OnDestroy {
    isActive = false;
    isLoading = false;
    masqueradedUserName$: Observable<string>;
    masqueradedRole$: Observable<string>;
    masqueradedUsername$: Observable<string>;
    private destroy$ = new Subject<void>();

    constructor(public masqueradeService: MasqueradeService) {
        this.masqueradedUserName$ = this.masqueradeService.masqueradedUserName$;
        this.masqueradedRole$ = this.masqueradeService.masqueradedRole$;
        this.masqueradedUsername$ = this.masqueradeService.masqueradedUsername$;
    }

    ngOnInit(): void {
        this.isActive = window.name === 'masquerade';
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    async stopMasquerade(): Promise<void> {
        try {
            this.isLoading = true;
            this.masqueradeService.stopMasquerade();
        } finally {
            this.isLoading = false;
        }
    }
}
